import React from "react";
import { connect } from "react-redux";
import ShippingSummaryBlock from "./components/ShippingSummaryBlock";
import "./style.scss";
import { deliverySelector } from "../../selectors/gears-checkout";
import { PickupInStoreCode } from "../../utils/lynkco-constants";

const ShippingInfoSummary = ({ shippingAddress, contactInfo, deliveryMethod, delivery }) => {
  return (
    <div className="shipping-info-summary">
      <div className="info-blocks-container">
        {shippingAddress && delivery.code !== PickupInStoreCode && <ShippingSummaryBlock {...shippingAddress} />}
        {contactInfo && <ShippingSummaryBlock {...contactInfo} />}
        {deliveryMethod && <ShippingSummaryBlock {...deliveryMethod} />}
      </div>
    </div>
  );
};

// ShippingInfoSummary.propTypes = {
//   shippingAddress: PropTypes.object,
//   contactInfo: PropTypes.object,
//   deliveryMethod: PropTypes.object
// };
const mapStateToProps = state => ({
  delivery: deliverySelector(state)
});
export default connect(mapStateToProps)(ShippingInfoSummary);
